import { TMainWidgetProps } from '@libs/types';
import React from 'react';

const Widget: React.FC<TMainWidgetProps> = () => {
    return false;
};

export default Widget;
